import React, { useState } from "react"
import { Dialog, DialogContent, TextField, makeStyles, Button, InputLabel } from '@material-ui/core'
import { postGDCRoadMap } from "@auteco/services/gdcServices"
import { currentDate } from "@auteco/constants"

const useStyles = makeStyles(() => ({
    dialogContent: {
        minWidth: '400px',
        display: 'flex',
        flexDirection: 'column',
        padding: '20px 24px'
    },
    textField: {
        marginTop: '20px'
    },
    sendBtn: {
        width: '140px',
        margin: '20px auto 0'
    }
}))

const DialogMessage = ({ open, onClose, id, partner, priority, reload }) => {
    const [contentRoadMap, setContentRoadMap] = useState({})
    const classes = useStyles()

    const updateContentRoadMap = ({ value, param }) => {
        setContentRoadMap((prev) => ({ ...prev, [param]: value }))
    }
    const postRoadMap = async () => {
        const body = {
            punto_guia_id: id,
            titulo: contentRoadMap.title,
            texto: contentRoadMap.text,
            valorar: contentRoadMap.value,
            prioridad: priority,
            costo: contentRoadMap.cost,
            finalizacion: contentRoadMap.time,
            solicitante: partner
        }
        const response = await postGDCRoadMap({ params: body })
        if (response.success === 1) {
            reload()
            onClose()
            setContentRoadMap(null)
        }
    }

    const handleClose = () => {
        setContentRoadMap(null)
        onClose()
    }
    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogContent className={classes.dialogContent}>
                <TextField
                    label='Título'
                    variant='outlined'
                    onChange={(e) => updateContentRoadMap({ value: e.target.value, param: 'title' })}
                />
                <TextField
                    label='Descripción'
                    variant='outlined'
                    className={classes.textField}
                    multiline
                    minRows={7}
                    onChange={(e) => updateContentRoadMap({ value: e.target.value, param: 'text' })}
                />
                <TextField
                    label='Beneficio'
                    type="number"
                    variant='outlined'
                    className={classes.textField}
                    onChange={(e) => updateContentRoadMap({ value: e.target.value, param: 'value' })}
                />
                <TextField
                    label='Inversión'
                    type="number"
                    variant='outlined'
                    className={classes.textField}
                    onChange={(e) => updateContentRoadMap({ value: e.target.value, param: 'cost' })}
                />
                <InputLabel htmlFor="tiempo-input" style={{ margin: '20px 0 5px 10px' }}>Tiempo estimado retorno de la inversión</InputLabel>
                <TextField
                    variant='outlined'
                    type="date"
                    style={{ width: '100%' }}
                    InputProps={{
                        inputProps: { min: currentDate },
                    }}
                    onChange={(e) => updateContentRoadMap({ value: e.target.value, param: 'time' })}
                />
                <Button
                    className={classes.sendBtn}
                    variant='contained'
                    color='primary'
                    disabled={!contentRoadMap?.title || !contentRoadMap?.text || !contentRoadMap?.value || !contentRoadMap?.cost || !contentRoadMap?.time}
                    onClick={postRoadMap}
                >Enviar
                </Button>
            </DialogContent>
        </Dialog>
    )
}

export { DialogMessage }